module.exports = __webpack_public_path__ + "static/media/01.027cd87d.jpg";